import { BannerAttrs } from "@locent/types";

import { BaseComponent } from "../base/baseComponent";

/** Banner组件类 */
export class BannerComponent extends BaseComponent<
  BannerAttrs & {
    [key: string]: string | number | boolean | object | null | undefined;
  }
> {
  constructor(
    data: Partial<
      BaseComponent<
        BannerAttrs & {
          [key: string]: string | number | boolean | object | null | undefined;
        }
      >
    > = {},
  ) {
    super(data);
  }
}
